import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIdentityCard = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M11.5 6.5h-3m1.68 2H8.5m3.666 4.333H3.833a2 2 0 0 1-2-2V5.166a2 2 0 0 1 2-2h8.334a2 2 0 0 1 2 2v5.667a2 2 0 0 1-2 2m-6.833-4c.46 0 .833-.373.833-.834v-.666a.833.833 0 0 0-1.666 0v.666c0 .46.373.834.833.834"
	})
});
export default SvgIdentityCard;
